// extracted by mini-css-extract-plugin
export default {"root":"gjOUjIAxNVdfqoYzeUlj5Q==","image":"+FREk4akSjxMC1oU9Ro01A=="};